import { render } from "./VoteChip.vue?vue&type=template&id=37126b28&scoped=true"
import script from "./VoteChip.vue?vue&type=script&lang=js"
export * from "./VoteChip.vue?vue&type=script&lang=js"

import "./VoteChip.vue?vue&type=style&index=0&id=37126b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37126b28"]])

export default __exports__